import { render, staticRenderFns } from "./scorePlate.vue?vue&type=template&id=b9aefbd6&scoped=true&"
import script from "./scorePlate.vue?vue&type=script&lang=js&"
export * from "./scorePlate.vue?vue&type=script&lang=js&"
import style0 from "./scorePlate.vue?vue&type=style&index=0&id=b9aefbd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9aefbd6",
  null
  
)

export default component.exports